import * as React from 'react';
import StylableHorizontalMenu from '../../StylableHorizontalMenu';
import { IStylableHorizontalMenuUITypeProps } from '../../../StylableHorizontalMenu.types';
import { MenuWrapperWrappable } from '../../components/MenuWrapperWrappable/MenuWrapperWrappable';
import { getClasses_flyout } from '../../components/MenuItem/styles/getClasses_flyout';
import { depth0PositionUpdaters } from '../../components/MenuItem/positionUpdaters/itemDepth0';
import { depth1PositionUpdaters } from '../../components/MenuItem/positionUpdaters/itemDepth1';

const StylableHorizontalMenu_WrapFlyout: React.FC<IStylableHorizontalMenuUITypeProps> = props => (
  <StylableHorizontalMenu
    {...props}
    menuWrapper={MenuWrapperWrappable}
    getMenuItemClasses={getClasses_flyout}
    positionUpdaters={[depth0PositionUpdaters, depth1PositionUpdaters]}
    // TODO: remove
    menuMode="wrap"
  />
);

export default StylableHorizontalMenu_WrapFlyout;
